<template>
  <BaseButtonV2
    class="rte-btn"
    type="link"
    color="text"
    @click="$emit('click', $event)"
  >
    <slot></slot>
  </BaseButtonV2>
</template>

<script>
export default {
  name: 'RteButton',
};
</script>

<style lang="scss" scoped>
.rte-btn.base-button {
    height: 1em;
    padding: 0.5em;
    margin: 0.25em;
    flex: 1;
    overflow: hidden;
    text-overflow: ellipsis;

    &:hover {
        background-color: #e7e7e7;
    }
}
</style>
